export const ShippingImportOriginEnum = {
  IMPORT_SHIPPING: "importShipping",
  IMPORT_TRACKING_SHIPPING: "importTrackingShipping",
};
